'use strict';

const Measurement = require('bunsen/models/inventory/Measurement');

module.exports = Object.freeze({
    display: {
        [Measurement.units.IN]: 'in.',
        [Measurement.units.MM]: 'mm',
        [Measurement.units.CM]: 'cm',
    },
    labels: {
        // are there constants for these properties?
        height: 'H',
        width: 'W',
        depth: 'D',
        length: 'L',
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/constants/measurementConstants.es.js